import React, { useContext, useEffect } from 'react';

import styled from 'styled-components';
import { ServiceRequestContext } from 'context/ServiceRequestContext';
import BadgeSVG from './badge-icon.svg';
import BadgeSVGSelected from './badge-icon-selected.svg';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const ilaDefault = `${CDN_URL}support/ticketing/icon-ila-default-lg.svg`;
const ilaSelected = `${CDN_URL}support/ticketing/icon-ila-selected-lg.svg`;

const Style = styled.div`
	.selections {
		display: flex;
		width: 100%;
		justify-content: center;
		align-items: center;
	}
	.selection {
		text-align: center;
		width: 150px;
		height: 100px;
		margin: 10px;
		cursor: pointer;
		img {
			width: 40px;
			height: 40px;
		}
	}
	.info-text {
		text-align: center;
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		.selection {
			width: 150px;
			height: 100px;
			margin: 10px;

			img {
				width: 60px;
				height: 60px;
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		margin-top: 30px;
		.selection {
			width: 200px;
			height: 240px;
			margin: 20px;

			img {
				width: 100px;
				height: 100px;
			}
		}
	}
`;

export const SelectionScreen = () => {
	const { inputs, change } = useContext(ServiceRequestContext);

	const badgeIcon = inputs?.type === 'datacenter' ? BadgeSVGSelected : BadgeSVG;
	const ilaIcon = inputs?.type === 'ila' ? ilaSelected : ilaDefault;

	useEffect(() => {}, []);

	function onSelection(type) {
		console.log('type ', type);
		change({ target: { name: 'type', value: type } });
	}

	return (
		<Style className='service-request-selection'>
			<div className='selections'>
				<div className='selection' onClick={() => onSelection('datacenter')}>
					<img src={badgeIcon} />
					<div className='body10'>Data Center</div>
				</div>
				<div className='selection' onClick={() => onSelection('ila')}>
					<img src={ilaIcon} />
					<div className='body10'>Fibre - ILA</div>
				</div>
			</div>

			<div className='info-text footer20'>
				If your request is within 24 hours please contact our support directly on
				<div className='footer60'>877.590.1684</div>
			</div>
		</Style>
	);
};
